import React from 'react'
import {
    VStack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'

//UTIL
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'

export default function FaqTitle({title}) {
    const styles = useMultiStyleConfig('Faq', {})
    const {searchAndTitleStyles} = styles || {}

    return (
        <VStack {...searchAndTitleStyles?.outerContainer}>
            <VStack {...searchAndTitleStyles?.midContainer}>
                <VStack {...searchAndTitleStyles?.innerContainer}>
                    {/**Since the title of the category is in the native language there is no need for a formatted message */}
                    {title === 'default' ? (
                        <Text {...searchAndTitleStyles?.titleText}>
                            <FormattedMessage
                                id="faq_page.search.title"
                                defaultMessage="Frequent Questions"
                            />
                        </Text>
                    ) : (
                        <Text
                            {...searchAndTitleStyles?.titleText}
                            dangerouslySetInnerHTML={{
                                __html: title,
                            }}
                        />
                    )}
                </VStack>
            </VStack>
        </VStack>
    )
}

FaqTitle.propTypes = {
    title: PropTypes.string,
    searchActive: PropTypes.bool,
}
